import React from 'react'
import {BsLinkedin} from 'react-icons/bs'

const HeaderSocial = () => {
  return (
    <div className='header_social'>
        <a href="https://www.linkedin.com/in/waristha-meethawee-3a820b150" target='_blank'><BsLinkedin/></a>
    </div>
  )
}

export default HeaderSocial